import AbstractService from '@/services/abstractService'

class ProjectTypesService extends AbstractService {
  endpoint = 'projectTypes'

  index() {
    return this.http.get(this.endpoint)
  }

  put(data) {
    console.log('data', data)
    console.log('type===>', typeof (data.image))
    // define append form
    const formData = new FormData()

    for (const key in data) {
      formData.append(key, data[key])
    }
    return this.http.put(`${this.endpoint}/${data.id}`, formData)
  }


}

const Service = new ProjectTypesService()

export default Service
